<script>
  import {supabase} from "./supabaseClient"
  import Carousel from 'svelte-carousel'
  import StandardHeader from "./StandardHeader.svelte"
  import StandardFooter from "./StandardFooter.svelte"
  import Profile from "./Profile.svelte"
  import { fade } from 'svelte/transition';
  import { onMount } from 'svelte';


 let newBoardTitle = '';
 let displayAddBoardErrror = '';
 const handleCreateBoard = async () => {
   if (newBoardTitle == '') {
     displayAddBoardErrror = 'You need to add a name for your board 🙂'
     return
   }
   let { data, error } = await supabase
    .rpc('create_board', {
      title:newBoardTitle
    })
  if (error) console.error(error)
  else console.log(data)

  debugger
   window.location.href = '/board?accessKey=' + data.access_key
   // window.location.href = '/board?id=' + data
 }

</script>
<StandardHeader />
<div class="pageContent">
  <div style="padding-left:60px; padding-right:60px">
    <h1>Fun Team Mood Check-ins</h1>

    <div style="display:flex; flex-direction:row ">
      <div style="flex-grow: 2">
        <p>Quick team check-ins that start your meeting in the right mood. </p>
        <form on:submit|preventDefault={handleCreateBoard}>
          <input size="25" autofocus type="Text" placeholder="Your team's name" bind:value={newBoardTitle} on:input={() => displayAddBoardErrror=''} />
          <button on:click={handleCreateBoard}>Try it, it's Free</button>
          <div style="height:30px"><span class="addBoardError" in:fade="{{ y: 200, duration: 1100 }}" hidden={displayAddBoardErrror==''}> {displayAddBoardErrror}</span> &nbsp;</div>
        </form>
      </div>

      <div style="width:60%; flex-grow: 2">
      <Carousel autoplay autoplayDuration={5000} width="200px">
        <img alt="Example Mood board used for Team Check-in" src="https://d1muf25xaso8hp.cloudfront.net/https%3A%2F%2Fs3.amazonaws.com%2Fappforest_uf%2Ff1623085437649x611103264670486100%2FHeroImageTeamCheckIn%20%284%29.png?w=544&h=335&auto=compress,&dpr=2&fit=max"/>
        <img alt="Example Mood board used for weekly team meeting"  src="https://d1muf25xaso8hp.cloudfront.net/https%3A%2F%2Fs3.amazonaws.com%2Fappforest_uf%2Ff1628785726348x593567045696048500%2FHeroImageWeeklyTeam%20%284%29.png?w=544&h=335&auto=compress,&dpr=2&fit=max"/>
        <img alt="Example Mood board used for Niko Niko calendar" src="https://d1muf25xaso8hp.cloudfront.net/https%3A%2F%2Fs3.amazonaws.com%2Fappforest_uf%2Ff1628788975102x564005234219067140%2FHeroImageNiko%20%284%29.png?w=544&h=335&auto=compress,&dpr=2&fit=max"/>
        <img alt="Example Mood board used for Sprint Retrospective" src="https://d1muf25xaso8hp.cloudfront.net/https%3A%2F%2Fs3.amazonaws.com%2Fappforest_uf%2Ff1623000059176x902780017280624400%2FHeroImageSprintRetro%20%285%29.png?w=544&h=335&auto=compress,&dpr=2&fit=max"/>
      </Carousel>
      </div>


    </div>

  </div>
  <div style="padding-left:60px; padding-right:60px">
  <h2>Features</h2>
  </div>
</div>
<StandardFooter />


  <!-- <Button depressed class="primary-color"  on:click="{handleSignup}">Sign Up</Button> -->
<style>
h1 {color: var(--blue); font-family: Poppins ExtraBold; font-size: 50px; }
h2 {color: var(--blue); font-family: Poppins ExtraBold; font-size: 25px; }
.pageContent{min-height: calc(100vh - 140px);}
/* .sc-carousel__carousel-container{width: 80% !important} */
  .addBoardError{color: red; vertical-align: top; font-size: 20px;}
</style>
